import status from './status'
import auth from './auth'
import createPayout from './create-payout'
import getPayoutStatus from './get-payout-status'
import getBalance from './get-balance'
import createPayment from './create-payment'

export default {
  status,
  auth,
  createPayout,
  getPayoutStatus,
  getBalance,
  createPayment,
}
